module.exports = __webpack_public_path__ + "img/image-show-load-eds-docs.png";